import React, { FC, useEffect, useState } from 'react'
import { Card, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getFileName, getItemFromPath } from '../../utils/dataTools'
import { getDomainName } from '../../utils/envVariables'
import { Link } from 'react-router-dom'
import './index.css'

interface FileUploadProps {
  name: string;
  placeholder: string;
  files: Array<File>;
  error: any;
  id: string;
  uploadedFile: Array<any>;
  removeListName: string;
  readonly: boolean;
  urlDirectory: string;
  warningMessage?: boolean;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

const FileUpload: FC<FileUploadProps> = ({ name, placeholder, files, error, id, uploadedFile, removeListName, readonly, urlDirectory, warningMessage, setFieldValue }: FileUploadProps) => {
  const [previousFiles, setPreviousFiles] = useState([])
  const [removeFileList, setRemoveFileList] = useState<Array<number>>([])
  const domainName = getDomainName()

  const handleRemoveLoadedFile = (file: any) => {
    setPreviousFiles(previousFiles.filter(prevFile => prevFile[id] !== file[id]))
    setRemoveFileList([...removeFileList, file[id]])
    setFieldValue(removeListName, [...removeFileList, file[id]])
  }

  const handleChangeFile = (event: any) => {
    const newFiles = [...event.target.files, ...files]
    setFieldValue(name, newFiles)
  }

  const handleRemoveFile = (file: File) => {
    const newFiles = files.filter((f) => f.name !== file.name)
    setFieldValue(name, newFiles)
  }

  useEffect(() => {
    if (uploadedFile) {
      setPreviousFiles(uploadedFile)
    }
  }, [uploadedFile])

  // Uploaded file preview
  const formLabel = 'Upload File(s)'

  return (
    <Card style={error ? { borderColor: '#dc3545', borderRadius: '0.25rem' } : { borderRadius: '0.25rem' }}>
      <Card.Body style={{ background: '#f7f7f7' }}>
        {
          !readonly && (
            <Row>
              <Form.Group as={Col} xs={12}>
                <Form.Label>{formLabel}</Form.Label>
                <InputGroup>
                  <Form.Control placeholder={placeholder} value={getFileName(files)} disabled />
                  <InputGroup.Append>
                    <label htmlFor={name} className='file-upload'>Locate file...</label>
                    <input 
                      id={name}
                      name={name}
                      type='file'
                      style={{ display: 'none' }}
                      onChange={(event: any) => handleChangeFile(event)}
                    />
                  </InputGroup.Append>
                </InputGroup>
                {
                  warningMessage && (
                    <Form.Text className='warning-text'>Maximum upload file size: 10MB</Form.Text>
                  )
                }
                {error ? (
                  <Form.Text className='form-error'>
                    {error}
                  </Form.Text>
                ) : null}
              </Form.Group>
            </Row>
          )
        }
        {
          (files.length > 0 || (previousFiles && previousFiles.length > 0)) ? (
            <>
              <Form.Label>Uploaded Files</Form.Label>
              <Card>
                <Card.Body style={{ display: 'flex', flexFlow: 'wrap' }}>
                  {
                    previousFiles && previousFiles.map((fileLoaded) => {
                      const fileLoadedName = getItemFromPath(fileLoaded.fileLocation, 'file')
                      const fileFolder = getItemFromPath(fileLoaded.fileLocation, 'folder')

                      return (
                        <div style={{ marginRight: 15 }} key={fileLoaded[id]}>
                          <FontAwesomeIcon icon={['fas', 'file-pdf']} />
                          {
                            id.includes('backgroundCheck') ? (
                              <span style={{ fontSize: '0.9rem', margin: '0px 8px' }}>
                                {fileLoadedName}
                              </span>
                            ) : (
                              <Link
                                to='route'
                                className='ml-2 mr-2'
                                style={{ fontSize: '0.9rem', margin: '0px 8px' }}
                                onClick={(event) => {
                                  event.preventDefault()
                                  window.open(`${domainName}/${urlDirectory}/${fileFolder}/${fileLoadedName}`)
                                }}
                              >
                                {fileLoadedName}
                              </Link>
                            )
                          }
                          {
                            !readonly ? (
                              <span onClick={() => handleRemoveLoadedFile(fileLoaded)}>
                                <FontAwesomeIcon icon={['fas', 'times-circle']} color='red' />
                              </span>
                            ) : (
                              <span>
                                <FontAwesomeIcon icon={['fas', 'times-circle']} color='grey' />
                              </span>
                            )
                          }
                        </div>
                      )}
                    )
                  }
                  {
                    files.map((file) => (
                      <div style={{ marginRight: 15 }} key={file.name}>
                        <FontAwesomeIcon icon={['fas', 'file-pdf']} />
                        <a href='#' className='ml-2 mr-2'  style={{ fontSize: '0.9rem', margin: '0px 8px' }}>{file.name}</a>
                        <span onClick={() => handleRemoveFile(file)}>
                          <FontAwesomeIcon icon={['fas', 'times-circle']} color='red' />
                        </span>
                      </div>
                    ))
                  }
                </Card.Body>
              </Card>
            </>
          ) : (
            readonly ? (
              <Card>
                <Card.Body style={{ padding: '0.5rem', display: 'flex' }}>
                  <span style={{ fontWeight: 'lighter', marginLeft: 10 }}>No Files Loaded</span>
                </Card.Body>
              </Card>
            ) : null
          )
        }
      </Card.Body>
    </Card>
  )
}

export default FileUpload